import { Routes } from "@angular/router";
import { EappregAppComponent } from "app/component/eappreg-app/eappreg-app.component";
import { EappregBusinessQuestionsComponent } from "app/component/eappreg-business-questions/eappreg-business-questions.component";
import { EappregConfirmComponent } from "app/component/eappreg-confirm/eappreg-confirm.component";
import { EappregCriteriaComponent } from "app/component/eappreg-criteria/eappreg-criteria.component";

import { EappregFuzzyMatchComponent } from "app/component/eappreg-fuzzy-match/eappreg-fuzzy-match.component";
import { EappregPermitMainComponent } from "app/component/eappreg-permit-main/eappreg-permit-main.component";
import { EappregPermitQuestionsComponent } from "app/component/eappreg-permit-questions/eappreg-permit-questions.component";
import { EappregQuestionnaireComponent } from "app/component/eappreg-questionnaire/eappreg-questionnaire.component";
import { EappregReceiptComponent } from "app/component/eappreg-receipt/eappreg-receipt.component";
import { EappregFastTrackComponent } from 'app/component/eappreg-fasttrack/eappreg-fasttrack.component';
import { EappregSelectsComponent } from 'app/component/eappreg-selects/eappreg-selects.component';
import { EappregTrcComponent } from "app/component/eappreg-trc/eappreg-trc.component";
import { DbErrorHandlerComponent } from "app/layouts/db-error-handler/db-error-handler.component";
import { ErrorPageComponent } from "app/layouts/error-page/error-page.component";
import { WarningPageComponent } from "app/layouts/warning-page/warning-page.component";
import { BusVerificationService, Qlevel1Service,FastTracklevel1Service } from "app/service/resolvers/qlevel1.service";
import { EappregL288MeasureComponent } from 'app/component/eappreg-L288-measure/eappreg-L288-measure.component';


  export const BusinessRegApp_ROUTE:Routes =[
    {
        path: '', redirectTo: 'eappreg_criteria', pathMatch: 'full'
    },
    {
        path:'eappreg_criteria',
        component:EappregCriteriaComponent
    },
	{
        path:'eappreg_selects',
        component:EappregSelectsComponent
    },
	{
        path:'eappreg_fasttrack',
        component:EappregFastTrackComponent,
    resolve:{
            fastTracklevel1Questions:FastTracklevel1Service,
			busVerificationQuestions:BusVerificationService
        }
    },
    {
        path:'eappreg_business_questions',
        component:EappregBusinessQuestionsComponent
    },
    {
        path:'db_error_handler',
        component:DbErrorHandlerComponent
    },
    {
        path:'error_page',
        component:ErrorPageComponent
    },
    {
        path:'eappreg_questionnaire',
        component:EappregQuestionnaireComponent,
        resolve:{
            level1Questions:Qlevel1Service,
            busVerificationQuestions:BusVerificationService
        }
    },
    {
        path:'eappreg_permit_main',
        component:EappregPermitMainComponent
    },
    {
        path:'eappreg_permit_questions',
        component:EappregPermitQuestionsComponent
    },
    {
        path:'eappreg_confirm',
        component:EappregConfirmComponent,
        resolve:{
            level1Questions:Qlevel1Service,
            busVerificationQuestions:BusVerificationService
        }
    },
    {
        path:'eappreg_receipt',
        component:EappregReceiptComponent
    },
    {
        path:'eappreg_app',
        component:EappregAppComponent
    },
    {
        path:'eappreg_trc',
        component:EappregTrcComponent
    },
    {
        path:'eappreg_fuzzy',
        component:EappregFuzzyMatchComponent
    },{
        path:'eappreg_L288',
        component:EappregL288MeasureComponent
    },{
        path:'warning_page',
        component:WarningPageComponent
    },
    {
        path:'**',
        component:ErrorPageComponent
    },

]